import {combineEpics} from 'redux-observable';

import demoEpic from './demoEpic';
import knowEpic from './knowEpic';
import experienceEpic from './experienceEpic';
import sessionEpic from './sessionEpic';
import appEpic from './appEpic';

export default combineEpics(demoEpic, knowEpic, sessionEpic, appEpic, experienceEpic);
